import { registerPage } from '@zillow/client-profiler-interface-cs';
import { logError } from '@zg-rentals/log-error';
import { MIN_LG } from '@/src/lib/breakpoints';

export type ClientProfilerPageName =
  | 'hotpads-srp'
  | 'hotpads-hdp'
  | 'hotpads-bdp'
  | 'hotpads-homepage'
  | 'hotpads-city-page'
  | 'hotpads-state-page'
  | 'hotpads-my-list';

// One image is built with ZG_ENV=production and deployed to every environment, so a
// NEXT_PUBLIC_ twin would bake to 'production' everywhere. RootLayout emits this at
// request time instead, from the runtime ZG_ENV.
export const ZG_ENV_META_NAME = 'zg-env';

function readZgEnvironment(): string {
  return document.querySelector<HTMLMetaElement>(`meta[name="${ZG_ENV_META_NAME}"]`)?.content || 'localhost';
}

export function registerClientProfilerPage(pageName: ClientProfilerPageName) {
  if (typeof window === 'undefined') return;

  const platform = window.matchMedia(MIN_LG).matches ? 'desktop' : 'mobile';

  try {
    registerPage({
      pageName,
      environment: readZgEnvironment(),
      platform,
    });
  } catch (e) {
    logError({
      error: e,
      errorType: 'ClientProfilerRegistrationError',
      context: { pageName },
    });
  }
}
